import { useTranslation } from 'react-i18next';
import { ConfigurationPageLayout } from '@admin/components/workspace-configuration/configuration-page-layout.tsx';
import {
  useWorkspaceConfiguration,
  useWorkspaceConfigurationQuery
} from '@admin/components/workspace-configuration/use-workspace-configuration.ts';

export const DomainConfiguration = () => {
  const { t } = useTranslation();
  const { workspace, workspaceId } = useWorkspaceConfiguration();
  const configurationQuery = useWorkspaceConfigurationQuery();
  const dnsConfiguration = configurationQuery.data?.dnsConfiguration;

  return (
    <ConfigurationPageLayout
      scope="domain"
      title={t('workspace.configuration.domain.title')}
      description={t('workspace.configuration.domain.description')}
      workspaceId={workspaceId}
      // Le domaine du workspace est connu avant la réponse de Vercel
      subject={workspace?.domain && `https://${workspace.domain}`}
      isValid={dnsConfiguration?.isValid}
      records={dnsConfiguration?.records}
      isLoading={configurationQuery.isLoading}
      isError={configurationQuery.isError}
    />
  );
};
